import CourseStats from './CourseStats';

export default CourseStats;
